export const callCenterPermissions = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_CADASTRO_OPERADOR_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_OPERADOR_EDITAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_OPERADOR_TOTAL,
  process.env.VUE_APP_CALLCENTER_CADASTRO_PAUSA_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_PAUSA_EDITAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_PAUSA_TOTAL,
  process.env.VUE_APP_CALLCENTER_CADASTRO_FILA_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_FILA_EDITAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_FILA_TOTAL,
  process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_OUVIR_GRAVACAO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_HISTORICO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_GRAVACAO_HISTORICO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_TOTAL,
  process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_OUVIR_GRAVACAO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_HISTORICO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_OUVIR_GRAVACAO_HISTORICO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_TOTAL,
  process.env.VUE_APP_CALLCENTER_RELATORIO_DISPONIBILIDADE_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_DISPONIBILIDADE_TOTAL,
  process.env.VUE_APP_CALLCENTER_MANUTENCAO_VISUALIZAR,
  process.env.VUE_APP_CALLCENTER_CONFIGURACAOMONITOROPERADOR_VISUALIZAR,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_TOTAL,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_PAUSA_DESPAUSA,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_REMOVER_FILA,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_DESLOGAR_OPERADOR,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_OUVIR_OPERADOR,  
  process.env.VUE_APP_CALLCENTER_MONITOR_VISUALIZAR,
  process.env.VUE_APP_CALLCENTER_MONITOR_PAUSA_DESPAUSA,
  process.env.VUE_APP_CALLCENTER_MONITOR_ADICIONAR_REMOVER_OPERADOR,
  process.env.VUE_APP_CALLCENTER_MONITOR_DESLOGAR_OPERADOR,
  process.env.VUE_APP_CALLCENTER_MONITOR_OUVIR_OPERADOR,
  process.env.VUE_APP_CALLCENTER_MONITOR_TOTAL,
  process.env.VUE_APP_CALLCENTER_CADASTRO_DEPARTAMENTO_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_DEPARTAMENTO_EDITAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_DEPARTAMENTO_TOTAL,
]

export const usersModulePermissions = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_VISUALIZAR,
  process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_EDITAR,
  process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_TOTAL,
  process.env.VUE_APP_USUARIOS_CADASTRO_USUARIOS_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_USUARIOS_CADASTRO_USUARIOS_EDITAR_CONDICIONADO,
  process.env.VUE_APP_USUARIOS_CADASTRO_USUARIOS_TOTAL,
  process.env.VUE_APP_USUARIOS_AUDITORIA_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_USUARIOS_AUDITORIA_TOTAL,
  process.env.VUE_APP_USUARIOS_TOKEN_VISUALIZAR,
]

export const satisfactionResearchPermissions = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_PESQUISA_SATISFACAO_CADASTRO_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_CADASTRO_EDITAR_CONDICIONADO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_CADASTRO_TOTAL,
  process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_OUVIR_GRAVACAO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_HISTORICO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_OUVIR_GRAVACAO_HISTORICO,
  process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_TOTAL,
]

export const relatoriosPABXPermissions = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_OUVIR_GRAVACAO,
  process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_TOTAL,
  process.env.VUE_APP_RELATORIO_PABX_CONFERENCIAS_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_RELATORIO_PABX_CONFERENCIAS_OUVIR_GRAVACAO,
  process.env.VUE_APP_RELATORIO_PABX_CONFERENCIAS_TOTAL,
]

export const monitorRamaisPermissions = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_MONITOR_RAMAIS_HABILITADO,
  process.env.VUE_APP_MONITOR_RAMAIS_OUVIR_RAMAL,
  process.env.VUE_APP_MONITOR_RAMAIS_TOTAL,
]

export const pabxPermissions = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_PABX_HABILITADO,
  // process.env.VUE_APP_RELATORIO_PABX_CONFERENCIAS_VISUALIZAR_CONDICIONADO,
  // process.env.VUE_APP_RELATORIO_PABX_CONFERENCIAS_OUVIR_GRAVACAO,
  // process.env.VUE_APP_RELATORIO_PABX_CONFERENCIAS_TOTAL,
]
